import ImeEntity from "../entities/Ime.Entity";
import IMECoverLetterEntity from "../entities/IMECoverLetter.Entity";
import SpecificBodyPartEntity from "../entities/SpecificBodyPart.Entity";

export default class ImeDataModel {
    ime: ImeEntity;
    coverLetter: IMECoverLetterEntity;
    specificBodyParts: Array<SpecificBodyPartEntity>;
}